import {useCallback, useDebugValue, useState} from 'react'
import type {Spec} from 'immutability-helper2';
import update from 'immutability-helper2'

export function useUpdateState<S>(initialState: S | (() => S)): [S, (s: Spec<S>) => void] {
    const [state, setState] = useState(initialState)
    const dispatch = useCallback((spec: Spec<S>) => setState(s => update(s, spec)), [setState])
    useDebugValue(state)
    return [state, dispatch]
}
